// TODO 考虑国际化，后续应该将其移出，用 MENU_MODE 替代吗
export const DICT_MENU_MODE = {
  '侧边栏模式': 'side',
  '顶部模式': 'head',
  '顶部+侧边栏模式': 'head-side',
};

export const MENU_MODE = ['side', 'head', 'head-side'];

export const FEEDBACK_PLACEMENT = {
  浮窗: 'float',
  个人中心: 'header'
} as const;
